export const toFixed = (num: string, fixed: number): string => {
  let re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?');
  return num.match(re)?.[0] || num;
};

export const getDecimalValue = (value: string, decimals: number): string => {
  if (isNaN(parseFloat(value))) return value;

  const num =
    typeof value === 'string'
      ? value?.replace(/\s/g, '')?.replace(String.fromCharCode(8722), '-')?.replace(',', '.')
      : '';

  const shorterValue: string = num ? toFixed(num, decimals) : num;

  return num.indexOf('.') > -1 && num.indexOf('.') < num.length - 1 ? shorterValue : num;
};
